import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { MeasurementSystem, MeasurementType } from '@models/module/fields/enums';

import { TenantSettingsEnum } from '@models/tenant';
import { UtilsService } from '@shared/services';
import { TenantStore } from '@signal-store/tenant.store';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'measurement',
})
export class MeasurementPipe implements PipeTransform {
  tenantStore = inject(TenantStore);
  utilsService = inject(UtilsService);

  transform(
    value: number | string | null | undefined,
    measurementType: MeasurementType,
    convertFromMeasurementSystem?: keyof typeof MeasurementSystem,
  ): string {
    const measurementSystem = this.tenantStore.getSetting(TenantSettingsEnum.measurement_system)
      .calculatedValue as keyof typeof MeasurementSystem;
    return this.utilsService.convertValueToMeasurementString(
      value,
      measurementType,
      measurementSystem,
      convertFromMeasurementSystem,
    );
  }
}
